import { isSSR } from './helpers';
import { getSessionStorageItem, setSessionStorageItem, StorageHelperKeys } from './storageHelpers';

// Thanks: https://stackoverflow.com/a/36807854/878361

function generateId() {
    return Math.random().toString().substring(2) + new Date().getTime();
}

export function assignTabId(): string {
    if (!isSSR()) {
        const tabId = sessionStorage.getItem(StorageHelperKeys.TAB_ID);
        if (typeof tabId === 'string' && tabId.length > 0) {
            // console.debug('tabId', `There is already a tab id '${tabId}'`);
            return tabId;
        }
        const newId = generateId();
        setSessionStorageItem(StorageHelperKeys.TAB_ID, newId);
        return newId;
    }
    return null;
}

export function getTabId(): string {
    return isSSR() ? null : getSessionStorageItem(StorageHelperKeys.TAB_ID);
}
